import { motion } from "framer-motion";
import { CountUp, IllustrativeBadge, Reveal } from "./bits";
import { Bars } from "./charts";

const METRICS = [
    { label: "Revenue Opportunity", prefix: "$", to: 4.2, decimals: 1, suffix: "M", desc: "Growth identified inside existing accounts and demand" },
    { label: "Recoverable Revenue", prefix: "$", to: 1.1, decimals: 1, suffix: "M", desc: "Dormant customers, expired quotes, lost opportunities" },
    { label: "Sales Process Opportunity", prefix: "$", to: 720, decimals: 0, suffix: "K", desc: "Conversion and productivity improvements in the funnel" },
    { label: "Potential Vendor Savings", prefix: "$", to: 846, decimals: 0, suffix: "K", desc: "Eligible operating expenses reviewed for overpayment" },
    { label: "Marketing Efficiency", prefix: "+", to: 18, decimals: 0, suffix: "%", desc: "Attributable pipeline per advertising dollar" },
];

const MIX = [
    { n: "GROW", v: 42, c: "rgba(30,136,247,0.75)" },
    { n: "RECOVER", v: 24, c: "rgba(57,119,246,0.75)" },
    { n: "REDUCE", v: 34, c: "rgba(11,18,32,0.7)" },
];

const OpportunityMap = () => (
    <div data-testid="opportunity-map">
        <div className="flex flex-wrap items-center justify-between gap-4">
            <h3 className="font-display text-3xl font-extrabold tracking-tightest sm:text-4xl">Your Profit Opportunity Map</h3>
            <IllustrativeBadge />
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {METRICS.map((m, i) => (
                <motion.div
                    key={m.label}
                    initial={{ opacity: 0, y: 22 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-10% 0px" }}
                    transition={{ duration: 0.7, delay: i * 0.09, ease: [0.16, 1, 0.3, 1] }}
                    className={`rounded-xl border border-ink/10 bg-white p-6 transition-colors duration-300 hover:border-vantera/50 ${i === 0 ? "sm:col-span-2 lg:col-span-2" : ""}`}
                    data-testid={`opportunity-metric-${i}`}
                >
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slategray">{m.label}</p>
                    <p className={`mt-4 font-display font-extrabold tracking-tightest text-ink ${i === 0 ? "text-6xl sm:text-7xl" : "text-4xl sm:text-5xl"}`}>
                        <CountUp to={m.to} decimals={m.decimals} prefix={m.prefix} suffix={m.suffix} />
                    </p>
                    <p className="mt-3 max-w-xs text-sm leading-relaxed text-slategray">{m.desc}</p>
                </motion.div>
            ))}
            <motion.div
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ duration: 0.7, delay: 0.45 }}
                className="rounded-xl border border-ink/10 bg-ink p-6"
            >
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-cloud">Opportunity mix by lever</p>
                <div className="mt-5">
                    <Bars items={MIX} dark height={120} />
                </div>
            </motion.div>
        </div>

        <Reveal delay={0.2}>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.16em] text-slategray">
                Sample figures shown for design demonstration only — not client results, guarantees, or claims.
            </p>
        </Reveal>
    </div>
);

export default OpportunityMap;